import { Box, InputAdornment, styled } from "@mui/material";
import { Icon } from "../../Icon";
import Tag from "../../Tag";

export const StyledTooltipWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
`;

export const StyledSelectValueContainer = styled("div")`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 1.571rem;
  gap: ${(props) => props.theme.wsc.spacing[0]};

  .MuiInputAdornment-root:not(:first-of-type) {
    margin-left: 0;
    margin-right: ${(props) => props.theme.wsc.spacing[0]};
  }
`;

export const StyledContentContainer = styled("div")`
  display: flex;
  flex-wrap: nowrap;
  gap: ${(props) => props.theme.wsc.spacing[0]};
  flex-grow: 1;
`;

export const StyledInnerTagWrapper = styled("div")`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  max-width: 100%;
`;

export const StyledAdornmentContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledIcon = styled(Icon)`
  line-height: 1rem;
`;

export const StyledTag = styled(Tag)`
  font-size: ${(props) => props.theme.wsc.typography.body2.fontSize};
  background-color: ${({ theme }) => theme.wsc.palette.neutral[500]};
  line-height: 1.571rem;

  &:hover {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[400]};
    cursor: pointer;
  }
`;

export const StyledInputAdornment = styled(InputAdornment)`
  cursor: pointer;
  color: ${({ theme }) => theme.wsc.palette.neutral[100]};
`;

export const StyledTooltipGamesContainer = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== "$largerGap",
})<{
  $largerGap?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  gap: ${({ $largerGap, theme }) =>
    $largerGap ? theme.wsc.spacing[3] : theme.wsc.spacing[2]};
`;

export const StyledTooltipDateTitle = styled("div")`
  padding: ${({ theme }) => theme.wsc.spacing[1]}
    ${({ theme }) => theme.wsc.spacing[1]} 0;
`;

export const StyledTooltipGameItemContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.wsc.spacing[0]};
  min-width: 20rem;
  padding: 0 ${({ theme }) => theme.wsc.spacing[0]};
`;
